export default __webpack_public_path__ + "static/media/complete_task.67a24aab.svg";